/* ========================================================================== 
   SKNBODY SITE SIGNUP POPUP
   - 25 second delay
   - 7 day dismissal cooldown
   - 30 day subscribed cooldown
   - Suppresses itself once the homepage Join section has been reached
   - ?skn_popup_test=1 bypasses cooldown and opens quickly for QA
   ========================================================================== */

(function () {
  'use strict';

  const root = document.querySelector('[data-skn-signup-popup]');
  if (!root) return;

  const dialog = root.querySelector('[data-skn-popup-dialog]');
  const closeButtons = root.querySelectorAll('[data-skn-popup-close]');
  const form = root.querySelector('.skn-signup-popup__form');
  const input = root.querySelector('[data-skn-popup-email]');
  const success = root.querySelector('[data-skn-popup-success]');
  const hasError = Boolean(root.querySelector('[data-skn-popup-error]'));
  const delay = Number(root.dataset.delay || 25000);

  const DISMISS_KEY = 'skn_signup_popup_dismissed_until';
  const SUBSCRIBED_KEY = 'skn_signup_popup_subscribed_until';
  const SUBMIT_SESSION_KEY = 'skn_signup_popup_submitted';
  const WEEK = 7 * 24 * 60 * 60 * 1000;
  const MONTH = 30 * 24 * 60 * 60 * 1000;

  let timer = null;
  let retryTimer = null;
  let isOpen = false;
  let joinSectionReached = false;
  let previousFocus = null;

  const testMode = new URLSearchParams(window.location.search).get('skn_popup_test') === '1';

  function readTimestamp(key) {
    try {
      return Number(window.localStorage.getItem(key) || 0);
    } catch (error) {
      return 0;
    }
  }

  function writeTimestamp(key, value) {
    try {
      window.localStorage.setItem(key, String(value));
    } catch (error) {}
  }

  function hasCooldown() {
    if (testMode) return false;
    const now = Date.now();
    return readTimestamp(DISMISS_KEY) > now || readTimestamp(SUBSCRIBED_KEY) > now;
  }

  function hasBlockingUi() {
    return Boolean(
      document.querySelector(
        '.drawer.active, [aria-modal="true"]:not([data-skn-popup-dialog]), .modal[open]'
      )
    );
  }

  function focusableElements() {
    return Array.from(
      dialog.querySelectorAll(
        'button:not([disabled]), input:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])'
      )
    ).filter(function (element) {
      return element.offsetParent !== null;
    });
  }

  function openPopup(force) {
    if (isOpen) return;
    if (!force && (hasCooldown() || joinSectionReached)) return;

    if (!force && hasBlockingUi()) {
      clearTimeout(retryTimer);
      retryTimer = window.setTimeout(function () {
        openPopup(false);
      }, 5000);
      return;
    }

    previousFocus = document.activeElement;
    root.hidden = false;
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('skn-signup-popup-open');

    requestAnimationFrame(function () {
      root.classList.add('is-open');
    });

    isOpen = true;

    window.setTimeout(function () {
      if (input) {
        input.focus({ preventScroll: true });
      } else if (dialog) {
        dialog.focus({ preventScroll: true });
      }
    }, 320);
  }

  function closePopup(options) {
    if (!isOpen) return;

    const opts = options || {};

    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('skn-signup-popup-open');

    if (opts.remember !== false) {
      writeTimestamp(DISMISS_KEY, Date.now() + WEEK);
    }

    window.setTimeout(function () {
      root.hidden = true;
    }, 280);

    isOpen = false;

    if (previousFocus && typeof previousFocus.focus === 'function') {
      try { previousFocus.focus({ preventScroll: true }); } catch (error) { previousFocus.focus(); }
    }
  }

  function handleKeydown(event) {
    if (!isOpen) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closePopup();
      return;
    }

    if (event.key !== 'Tab') return;

    const focusable = focusableElements();
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  closeButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      closePopup();
    });
  });

  document.addEventListener('keydown', handleKeydown);

  if (form) {
    form.addEventListener('submit', function () {
      try {
        window.sessionStorage.setItem(SUBMIT_SESSION_KEY, '1');
      } catch (error) {}
    });
  }

  const joinSection = document.querySelector('[data-skn-home-join], #skn-join');
  if (joinSection && 'IntersectionObserver' in window) {
    const joinObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && entry.intersectionRatio > 0.12) {
          joinSectionReached = true;
          clearTimeout(timer);
          joinObserver.disconnect();
        }
      });
    }, { threshold: [0, 0.12] });

    joinObserver.observe(joinSection);
  }

  let submittedFromPopup = false;
  try {
    submittedFromPopup = window.sessionStorage.getItem(SUBMIT_SESSION_KEY) === '1';
  } catch (error) {}

  if (submittedFromPopup && (success || hasError)) {
    try { window.sessionStorage.removeItem(SUBMIT_SESSION_KEY); } catch (error) {}

    if (success) {
      writeTimestamp(SUBSCRIBED_KEY, Date.now() + MONTH);
      writeTimestamp(DISMISS_KEY, 0);
    }

    window.setTimeout(function () {
      openPopup(true);
    }, 250);
    return;
  }

  if (hasCooldown()) return;

  timer = window.setTimeout(function () {
    if (document.hidden) {
      const onVisible = function () {
        if (!document.hidden) {
          document.removeEventListener('visibilitychange', onVisible);
          openPopup(false);
        }
      };
      document.addEventListener('visibilitychange', onVisible);
      return;
    }

    openPopup(false);
  }, testMode ? 700 : delay);
})();
